var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { PageLayout, withAnalytics, graphql, compose } from "@atlassiansox/microscopekit";
import releaseHistoryQuery from "../models/service-release-history.query.graphql";
import { EnvironmentsView } from "./EnvironmentsView";
import { ReleaseTableView } from "./ReleaseTableView";
import styled from "styled-components";
export var MoreButton = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 50px;\n  text-align: center;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  margin-top: 50px;\n  text-align: center;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var ReleasesView = /** @class */ (function (_super) {
    __extends(ReleasesView, _super);
    function ReleasesView(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchMoreReleaseGroups = function (env) {
            _this.props.data.fetchMore({
                variables: {
                    env: env,
                    pageSize: _this.props.pageSize,
                    page: _this.state.releaseGroups[env].length / _this.props.pageSize,
                },
                updateQuery: function (prev, _a) {
                    var fetchMoreResult = _a.fetchMoreResult;
                    if (!fetchMoreResult) {
                        return {
                            service: null,
                        };
                    }
                    else {
                        return fetchMoreResult;
                    }
                }
            }).then(function (result) {
                if (result.data.service === null) {
                    return;
                }
                var releaseGroupsCount = __assign({}, _this.state.releaseGroupsCount);
                releaseGroupsCount[env] = result.data.service.releaseHistory.releaseGroupsCount;
                var releaseGroups = __assign({}, _this.state.releaseGroups);
                releaseGroups[env] = __spreadArrays(_this.state.releaseGroups[env], result.data.service.releaseHistory.releaseGroups);
                _this.setState({
                    releaseGroupsCount: releaseGroupsCount,
                    releaseGroups: releaseGroups
                });
            });
        };
        _this.setSelectedEnv = function (i) {
            var env = _this.props.environments[i];
            _this.setState({
                selectedEnv: env,
            });
            if (_this.state.releaseGroups[env].length === 0) {
                _this.fetchMoreReleaseGroups(env);
            }
        };
        var releaseGroups = {};
        var releaseGroupsCount = {};
        var selectedEnv = _this.props.environments[0];
        _this.props.environments.map(function (env) {
            releaseGroups[env] = [];
            releaseGroupsCount[env] = 0;
            return null;
        });
        // For testing
        releaseGroups[selectedEnv] = _this.props.data != null && _this.props.data.service != null ? _this.props.data.service.releaseHistory.releaseGroups : [];
        _this.state = {
            selectedEnv: selectedEnv,
            releaseGroups: releaseGroups,
            releaseGroupsCount: releaseGroupsCount,
        };
        return _this;
    }
    ReleasesView.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.data != null && this.state.releaseGroupsCount[this.props.data.variables.env] === 0 && this.props.data.service != null) {
            var releaseGroupsCount = this.state.releaseGroupsCount;
            releaseGroupsCount[this.props.data.variables.env] = this.props.data.service.releaseHistory.releaseGroupsCount;
            var releaseGroups = this.state.releaseGroups;
            releaseGroups[this.props.data.variables.env] = this.props.data.service.releaseHistory.releaseGroups;
            this.setState({
                releaseGroups: releaseGroups,
                releaseGroupsCount: releaseGroupsCount,
            });
        }
    };
    ReleasesView.prototype.render = function () {
        var _this = this;
        return (React.createElement(PageLayout, { title: "Release History", actions: React.createElement(EnvironmentsView, { environments: this.props.environments, selectedEnv: this.state.selectedEnv, setSelectedEnv: this.setSelectedEnv }) },
            React.createElement(ReleaseTableView, { id: this.props.id, track: this.props.track, releaseGroups: this.state.releaseGroups[this.state.selectedEnv] }),
            this.state.releaseGroupsCount[this.state.selectedEnv] > this.state.releaseGroups[this.state.selectedEnv].length &&
                React.createElement(MoreButton, { onClick: function () { return _this.fetchMoreReleaseGroups(_this.state.selectedEnv); } }, "More...")));
    };
    return ReleasesView;
}(React.Component));
export { ReleasesView };
export var Releases = compose(graphql(releaseHistoryQuery), withAnalytics)(ReleasesView);
var templateObject_1;
